var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_21275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77654e-08 12.1875C7.77654e-08 13.7408 1.25923 15 2.8125 15H10.3125C11.8658 15 13.125 13.7408 13.125 12.1875V2.8125C13.125 1.25923 11.8658 0 10.3125 0H2.8125C1.25923 0 7.77654e-08 1.25923 7.77654e-08 2.8125V12.1875ZM2.8125 13.125C2.29477 13.125 1.875 12.7052 1.875 12.1875V2.8125C1.875 2.29477 2.29477 1.875 2.8125 1.875H10.3125C10.8302 1.875 11.25 2.29477 11.25 2.8125V12.1875C11.25 12.7052 10.8302 13.125 10.3125 13.125H2.8125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 11.25H5.625V9.375H6.5625C8.11577 9.375 9.375 8.11577 9.375 6.5625C9.375 5.00923 8.11577 3.75 6.5625 3.75H3.75V11.25ZM5.625 7.5V5.625H6.5625C7.08023 5.625 7.5 6.04477 7.5 6.5625C7.5 7.08023 7.08023 7.5 6.5625 7.5H5.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 31.0625V14.0625H5.625V31.0625H7.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 30.125H0V32H32V30.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 28.25H32V23.5625C32 22.0092 30.7408 20.75 29.1875 20.75H12.3125C10.7592 20.75 9.5 22.0092 9.5 23.5625V28.25ZM11.375 26.375V23.5625C11.375 23.0448 11.7948 22.625 12.3125 22.625H29.1875C29.7052 22.625 30.125 23.0448 30.125 23.5625V26.375H11.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0769 21.391L28.6293 17.0481C28.2464 15.8997 27.1717 15.125 25.9611 15.125H15.5389C14.3283 15.125 13.2536 15.8997 12.8707 17.0481L11.4231 21.391L13.2019 21.984L14.6495 17.6411C14.6495 17.6411 14.6495 17.6411 14.6495 17.6411C14.7772 17.2582 15.1354 17 15.5389 17H25.9611C26.3646 17 26.7228 17.2582 26.8505 17.641C26.8505 17.641 26.8505 17.641 26.8505 17.641L28.2981 21.984L30.0769 21.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 31.0625V27.3125H15.125V31.0625H17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 27.3125V31.0625H13.25V27.3125H11.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.125 31.0625V27.3125H28.25V31.0625H30.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 27.3125V31.0625H26.375V27.3125H24.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_21275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.91d54fdc1f8f9fa863ff9c9cb15ae0ca.svg";
export { ForwardRef as ReactComponent };